import { BeaufortCode } from "./beaufort.code";

export class WeatherInfo {
    public temperature!: number;
    public windSpeed!: number;
    public windDirection!: string;
    public windGust!: number;
    public totalCloudCover!: number;
    public humidity!: number;
    public precipitation!: number;
    public visibility!: number;
    public ptype!: number;
    public beaufortLevel!: BeaufortCode;
}